import DlsLink from "@galaxy-io/dls/links/Link";
import Text, { TextSize, TextVariant, TextWeight } from "@galaxy-io/dls/text/Text";
import { t } from "@galaxy-io/dls/theme/tokens/t";
import Widget from "@galaxy-io/dls/widget/Widget";
import type { ActivityItem } from "@gtm/contracts";
import { styled } from "@linaria/react";
import { safeUrl } from "@/lib/utils";

const Context = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${t.space[4]};
  min-width: 0;
  overflow-wrap: anywhere;
`;

export function CommentContext({
  context,
  asWidget,
}: {
  context: ActivityItem["commentContext"];
  asWidget?: boolean;
}) {
  const url = safeUrl(context?.url);
  if (!context || !url) return null;
  const label = context.kind === "post" ? "Post" : context.kind === "issue" ? "Issue" : "PR";
  const Frame = asWidget ? Widget : Context;
  return (
    <Frame
      aria-label={`Parent ${context.kind === "post" ? "post" : context.kind === "issue" ? "issue" : "pull request"}`}
    >
      <Text
        size={TextSize.BODY_SM}
        variant={TextVariant.SECONDARY}
        weight={asWidget ? TextWeight.MEDIUM : undefined}
      >
        {label}
        {context.number ? ` #${context.number}` : ""}
      </Text>
      {context.title && <Text isSelectable>{context.title}</Text>}
      <DlsLink href={url} isExternal>
        <Text as="span" size={TextSize.BODY_SM} isUnderlined isSelectable>
          {url}
        </Text>
      </DlsLink>
    </Frame>
  );
}
